export default __webpack_public_path__ + "static/media/item5.90f09729.png";